export enum CoverCropExploitation {
    RESTITUTE = "restitue",
    EXPORTED = "exporte"
}
